module.exports = new __parcel__URL__("project-img2.32500b84.png").toString();